// Scene: Oscillation
// Three RGB circles drifting continuously via independent sine waves.
// Phase offsets are randomised on creation, so every mount starts
// from a unique state. The scene loops indefinitely.

const rand = () => Math.random() * Math.PI * 2;

const CIRCLE_BASES = [
  { r: 255, g: 0,   b: 0,   txA: 0.18, txF: 2.9e-4, tyA: 0.13, tyF: 2.1e-4, sA: 0.10, sF: 1.7e-4, sB: 0.42 },
  { r: 0,   g: 255, b: 0,   txA: 0.14, txF: 2.3e-4, tyA: 0.17, tyF: 3.1e-4, sA: 0.09, sF: 2.3e-4, sB: 0.40 },
  { r: 0,   g: 0,   b: 255, txA: 0.16, txF: 1.9e-4, tyA: 0.11, tyF: 2.7e-4, sA: 0.11, sF: 1.5e-4, sB: 0.44 },
];

export function createOscillationScene(w, h) {
  const minDim = Math.min(w, h);

  // Randomise phase offsets once per scene instance
  const circles = CIRCLE_BASES.map((base) => ({
    ...base,
    txP: rand(),
    tyP: rand(),
    sP:  rand(),
  }));

  return {
    duration: Infinity,

    getCircles(t) {
      return circles.map((o) => ({
        r: o.r, g: o.g, b: o.b,
        cx:     w * 0.5 + Math.sin(t * o.txF + o.txP) * o.txA * w,
        cy:     h * 0.5 + Math.cos(t * o.tyF + o.tyP) * o.tyA * h,
        radius: minDim * (o.sB + Math.sin(t * o.sF + o.sP) * o.sA),
      }));
    },
  };
}
